import { render, staticRenderFns } from "./DeliverableSettings.vue?vue&type=template&id=06b344dc&scoped=true"
import script from "./DeliverableSettings.vue?vue&type=script&lang=js"
export * from "./DeliverableSettings.vue?vue&type=script&lang=js"
import style0 from "./DeliverableSettings.vue?vue&type=style&index=0&id=06b344dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b344dc",
  null
  
)

export default component.exports